import { useTranslation } from 'react-i18next'

import { EnvelopeIcon, HourglassMediumIcon, WarningCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { returnStatuses } from '@reveni-io/reveni-ui'

import { orderTransactionTypes } from '@/constants'

import * as Styles from './styles'

const ProcessCompletedTitle = ({ orderTransactionType, paymentPending, orderStatus }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getTitle = () => {
    if (orderStatus === returnStatuses.onHold) return <span>{t('Solicitud pendiente de aprobación')}</span>

    if (orderStatus === returnStatuses.cancelled) return <span>{t('Solicitud cancelada')}</span>

    if ([orderTransactionTypes.exchange, orderTransactionTypes.mixed].includes(orderTransactionType)) {
      return <span>{t(paymentPending ? 'Pago pendiente' : 'Solicitud recibida')}</span>
    }
    return <span>{t('Solicitud recibida')}</span>
  }

  const getIcon = () => {
    if (orderStatus === returnStatuses.onHold) {
      return <HourglassMediumIcon size={80} alt="onHoldIcon" color={theme.colors.orange.tone500} />
    }

    if (paymentPending || orderStatus === returnStatuses.cancelled) {
      return <WarningCircleIcon size={80} alt="warningIcon" />
    }

    return <EnvelopeIcon color={theme.colors.blue.tone500} size={80} alt="successIcon" />
  }

  return (
    <Styles.Container>
      <Styles.IconContainer orderCancelled={orderStatus === returnStatuses.cancelled} paymentPending={paymentPending}>
        {getIcon()}
      </Styles.IconContainer>
      <h1>{getTitle()}</h1>
    </Styles.Container>
  )
}

export default ProcessCompletedTitle
